import { Outlet, Navigate } from "react-router-dom";
import { Divider } from "@heroui/react";
import { LOGO_URL } from "@/constants";
import { ThemedText } from "@/components/ui";
import Cookies from "js-cookie";

const AuthLayout = () => {
    const isAuthenticated = Cookies.get("is_logged_in") === "true";

    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return (
        <div className="bg-default-50 flex min-h-screen w-full flex-col dark:bg-zinc-900">
            {/* Navbar */}
            <nav className="border-default-200 flex items-center justify-between border-b bg-white px-6 py-3 dark:border-zinc-700 dark:bg-zinc-800">
                <div className="flex items-center gap-3">
                    <img
                        src={LOGO_URL}
                        alt="Mansoer Group"
                        className="h-8 object-contain"
                    />
                    <Divider orientation="vertical" className="h-5" />
                    <ThemedText
                        as="span"
                        variant="default"
                        size="sm"
                        className="font-semibold"
                    >
                        Mansoer Group
                    </ThemedText>
                </div>
                <ThemedText as="span" variant="secondary" size="xs">
                    Business Management System
                </ThemedText>
            </nav>

            {/* Main Content */}
            <main className="flex flex-1 flex-col items-center justify-center px-4 py-8">
                <div className="w-full max-w-md">
                    <Outlet />
                </div>
            </main>

            {/* Footer */}
            <footer className="border-default-200 flex items-center justify-between border-t bg-white px-6 py-3 dark:border-zinc-700 dark:bg-zinc-800">
                <ThemedText variant="secondary" size="xs">
                    &copy; {new Date().getFullYear()} Mansoer Group. All rights
                    reserved.
                </ThemedText>
                <div className="flex items-center gap-4">
                    <ThemedText
                        as="span"
                        variant="secondary"
                        size="xs"
                        className="cursor-pointer hover:text-zinc-600 dark:hover:text-zinc-300"
                    >
                        Privacy Policy
                    </ThemedText>
                    <ThemedText
                        as="span"
                        variant="secondary"
                        size="xs"
                        className="cursor-pointer hover:text-zinc-600 dark:hover:text-zinc-300"
                    >
                        Support
                    </ThemedText>
                </div>
            </footer>
        </div>
    );
};

export default AuthLayout;
